import { z } from 'zod';

import type { PatchAdminV1OrgStoresIdBody, Store } from '@nucleus-commerce/api-client/admin';

export const GOOGLE_PRODUCT_CATEGORY_MAX = 200;

export const feedSettingsSchema = z.object({
  googleProductCategory: z
    .string()
    .trim()
    .max(GOOGLE_PRODUCT_CATEGORY_MAX, { error: 'feeds:validation.categoryLength' }),
  includeOutOfStock: z.boolean(),
});

export type FeedSettingsForm = z.infer<typeof feedSettingsSchema>;

export function fromFeedSettings(store: Pick<Store, 'settings'>): FeedSettingsForm {
  const { feeds } = store.settings;
  return {
    googleProductCategory: feeds.googleProductCategory,
    includeOutOfStock: feeds.includeOutOfStock,
  };
}

/** Only the two editable fields; the channel tokens are set by rotate-token and never sent here. */
export function toFeedSettingsPatch(values: FeedSettingsForm): PatchAdminV1OrgStoresIdBody {
  return {
    settings: {
      feeds: {
        googleProductCategory: values.googleProductCategory,
        includeOutOfStock: values.includeOutOfStock,
      },
    },
  };
}
